module.exports = __webpack_public_path__ + "static/media/pots.b158bb36.svg";